import { isAfterOrEqual } from '@Utils/versionUtils';
import Permission from '@Constants/permissions';

export const errorMessages = {
    LOCKED_ACCOUNT: {
        // '7.3.0': 'User is not enabled',  // (example usage)
        // '6.0.3': 'User locked',          // (example usage)
        legacy: 'User not enabled'
    },
    UNAUTHORIZED: {
        // '7.3.0': 'Unauthorized Request', // (example usage)
        legacy: "The system can't be reached, try logging in again or check your credentials."
    },
    INVALID_CREDENTIALS: {
        // '7.4.0': 'Username or password is invalid',  // (example usage)
        legacy: 'Credentials supplied are not valid'
    },
    NO_SCORECARD_RULES: {
        legacy: 'No scorecard rules'
    },
    NO_ACTIVE_SCORECARD_RULES: {
        legacy: 'No active scorecard rules'
    },
    UNABLE_TO_CONNECT_TO_SERVICE: {
        legacy: 'Unable to connect to scorecard service'
    }
};

const permissions = {
    scorecard_admin: {
        '8.1.0': [Permission.ADMIN_LOGICAPPS, Permission.FLOWABLE_REST]
    },
    canAnalyzeLabels_ViewAll: {
        legacy: [
            Permission.ANALYTICS_READ,
            Permission.CONTRACT_UPLOAD,
            Permission.CONTRACT_READ,
            Permission.VIEWS_ALL_VIEW
        ]
    },
    canAnalyzeLabels_CustomViews: {
        legacy: [
            Permission.ANALYTICS_READ,
            Permission.CONTRACT_UPLOAD,
            Permission.CONTRACT_READ,
            Permission.VIEWS_READ
        ]
    },
    canAnalyzeScorecard: {
        legacy: [
            Permission.ANALYTICS_READ,
            Permission.CONTRACT_UPLOAD,
            Permission.CONTRACT_READ,
            Permission.CONTRACT_WRITE,
            Permission.VIEWS_READ
        ]
    },
    scorecard: {
        '7.5.0': [Permission.LOGICAPP_RUN, Permission.LOGICAPP_READ, Permission.FLOWABLE_REST],
        '7.4.0': [Permission.DIGAPP_READ, Permission.FLOWABLE_REST],
        '7.3.0': [Permission.DIGAPP_READ],
        legacy: [Permission.CONTRACT_READ]
    }
};

const apis = {
    scorecard: {
        '7.3.0': 'v1/scorecards',
        legacy: 'scorecards'
    },
    digitalapps: {
        '7.5.0': 'v1/digitalapps?digAppType=scorecardanalyzer&isActive=true',
        '7.3.0': 'v1/digitalapps',
        legacy: 'digitalapps'
    },
    startSLEProcess: {
        '7.5.0': '/v1/digitalapps/{digAppId}/start'
    },
    scorecardRules: {
        '7.5.0': '/v1/digitalapps/{digAppId}/scorecard-rules?limitInput=1000&offsetInput=0'
    },
    analyticsStatus: {
        '8.1.0': '/v2/status?expand=tasks,languages',
        legacy: '/v1/system/status'
    }
};

export function getPermissionByVersion(type, version) {
    let value = '';
    Object.keys(permissions[type]).forEach(key => {
        if (!value && key === 'legacy') value = permissions[type].legacy;
        if (!value && isAfterOrEqual(key, version)) {
            value = permissions[type][key];
        }
    });

    return value;
}

export function getAPIByVersion(type, version) {
    let value = '';
    Object.keys(apis[type]).forEach(key => {
        if (!value && key === 'legacy') value = apis[type].legacy;
        if (!value && isAfterOrEqual(key, version)) {
            value = apis[type][key];
        }
    });

    return value;
}

export function getErrorMessageByVersion(type, version) {
    let value = '';
    Object.keys(errorMessages[type]).forEach(key => {
        if (!value && key === 'legacy') value = errorMessages[type].legacy;
        if (!value && isAfterOrEqual(key, version)) {
            value = errorMessages[type][key];
        }
    });

    return value;
}
